import React from 'react'
import StandardProductDashboard from './StandardProductDashboard'

/**
 * Corporate — Sky's corporate dashboard.
 *
 * Four low-volume campaigns (~633 comments in 90 days). Sparse by nature rather than by fault.
 *
 * It is deliberately three lines. A department's dashboard is an ARRANGEMENT,
 * and today every department arranges the same way, so this file's only job is
 * to name the product and its copy. When Corporate asks for something different,
 * this is the file that changes: drop StandardProductDashboard, compose the kit
 * primitives directly, and nothing else in the codebase moves.
 */
export const CorporateDashboard: React.FC = () => (
  <StandardProductDashboard
    product="corporate"
    title="Corporate"
    subtitle="Employer brand, corporate communications and customer-facing comms."
  />
)

export default CorporateDashboard
